/**
 * Image view component.
 * @module components/theme/View/ImageView
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import prettybytes from 'pretty-bytes';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import config from '@plone/volto/registry';
import { generateImageSizes } from '@fhnw/helpers/DesignSystem/imageSizes';

/**
 * Image view component class.
 * @function ImageView
 * @params {object} content Content object.
 * @returns {string} Markup of the component.
 */
const ImageView = ({ content }) => {
  const Image = config.getComponent({ name: 'Image' }).component;

  return (
    <section className="page__section page__section--followup">
      {content?.image?.download && (
        <figure className="media">
          <a href={flattenToAppURL(content.image.download)}>
            <Image
              item={content}
              imageField="image"
              alt={content.image_alt_text || content.title} // Besserer Fallback
              sizes={generateImageSizes({ max: '100vw' })} // sizes hinzufügen
              responsive={true}
              className="media__object"
            />
            <figcaption className="media__caption">
              <FormattedMessage
                id="Size: {size}"
                defaultMessage="Size: {size}"
                values={{ size: prettybytes(content.image.size) }}
              />
              &nbsp; &mdash; &nbsp;
              <FormattedMessage
                id="Click to download full sized image"
                defaultMessage="Click to download full sized image"
              />
            </figcaption>
          </a>
        </figure>
      )}
    </section>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
ImageView.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    image: PropTypes.shape({
      scales: PropTypes.shape({
        preview: PropTypes.shape({
          download: PropTypes.string,
        }),
      }),
    }),
  }).isRequired,
};

export default ImageView;
